import { Box } from "@chakra-ui/react";

export default function Divider(props) {
  return <Box mx="16px" bg="#bfbfbf" height="1px" opacity={0.4} {...props} />;
}
